import styled from "@emotion/styled";
import React, { useState, useEffect } from "react";
import { useCanvasMetrics } from "utils/canvas";
import t from "translations";
import { useBackendPrice } from "utils/price";

const SummeryWrap = styled.div({
  margin: "15px 0",
  ">.dpe-info": {
    display: "flex",
    flexDirection: "row",
    flexBasis: "60%",
    color: "#666",
    ">img": {
      width: 75,
      height: 75,
      objectFit: "cover",
      marginRight: 5,
      border: "1px solid #eee",
    },
    span: {
      verticalAlign: "top",
      display: "inline-block",
      width: 100,
    },
    b: {
      verticalAlign: "top",
      display: "inline-block",
      width: 140,
    },
  },
  ".dpe-price": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "10px",
    ">b": {
      fontWeight: "900",
      fontSize: 30,
      width: "auto",
      color: "black",
    },
    ">span": {
      color: "#666",
      width: "auto",
      fontSize: 12,
      marginRight: 5,
      marginLeft: 10,
    },
  },
});

export const Summery = ({ product, proboOptions }) => {
  const { width, height, radius } = useCanvasMetrics();
  const { total } = useBackendPrice();

  if (!product) {
    return null;
  }

  const { taxPercent, image, deliveryInfo } = product;

  const optionsWithoutSize = proboOptions?.filter(
    (opt) => opt.type_code !== "width" && opt.type_code !== "height"
  );
  const proboWidth = parseInt(
    proboOptions.find((opt) => opt.type_code === "width")?.value,
    10
  );
  const proboHeight = parseInt(
    proboOptions.find((opt) => opt.type_code === "height")?.value,
    10
  );
  const sizeLabel = proboOptions.find((opt) => opt.type_code === "width")
    ?.parent_name;

  const showProboSize =
    Number.isFinite(proboWidth) && Number.isFinite(proboHeight);

  const optionsToDisplay = showProboSize ? optionsWithoutSize : proboOptions;
  const proboOptionsJSX = (
    <>
      {showProboSize && (
        <div>
          <span>{sizeLabel}: </span>
          <b>{`${proboWidth}x${proboHeight} cm`}</b>
        </div>
      )}
      {optionsToDisplay?.map((opt) => {
        const { value, name, parent_name, unit_code } = opt;
        return (
          <div>
            <span>{value === null ? parent_name : name}: </span>
            <b>
              {value === null ? name : value}{" "}
              {unit_code !== "pc" && (unit_code ?? "")}
            </b>
          </div>
        );
      })}
    </>
  );

  const defaultOptionsJSX = (
    <>
      <div>
        <span>{t.size}: </span>
        <b>
          {width}x{height} cm
        </b>
      </div>
      {radius > 0 && (
        <div>
          <span>{t.radius}: </span>
          <b>{radius} cm</b>
        </div>
      )}
      {deliveryInfo && (
        <div>
          <span>{t.deliveryTime}: </span>
          <b>{deliveryInfo}</b>
        </div>
      )}
    </>
  );

  return (
    <>
      <b style={{ fontSize: 16 }}>{t.summery}</b>
      <br />
      <SummeryWrap>
        <div className="dpe-info">
          <img src={image} alt="product" />
          <div>
            <div className="dpe-price">
              <b>{total}</b>
              <br />
              <span>
                Inkl. {taxPercent}% MwSt. <br />
                zzgl. Versandkosten
              </span>
            </div>
            {product?.proboProduct ? proboOptionsJSX : defaultOptionsJSX}
          </div>
        </div>
      </SummeryWrap>
    </>
  );
};
